<span *ngIf="brigade" [ngbPopover]="brigadePopContent" placement="bottom-left" triggers="manual" container="body" #p2="ngbPopover" (click)="toggleWithBrigadeContext(p2)">
  <a class="link link--dotted-blue-dark">
    {{ brigade && brigade.brigade_name }}
  </a>
</span>

<ng-template #brigadePopContent>
  <div>
    <app-loader *ngIf="brigadeLoading" [size]="'small'"></app-loader>
    <div *ngIf="!brigadeLoading">
      <div *ngIf="!brigadeError">
        <div *ngIf="brigadeExtra.is_dissolved">Бригада расформирована</div>
        <div class="w-320" *ngIf="!brigadeExtra.is_dissolved">
          <div class="grid">
            <div class="grid__box grid__box--size-5">
              <span class="title title--s">Бригада</span>
            </div>
            <div class="grid__box grid__box--size-7">
              <a
                class="link"
                [routerLink]="[
                  '/',
                  WORK_SHIFT_PATHS.work_shift,
                  WORK_SHIFT_PATHS.work_shift_s,
                  brigadeExtra.sector_id,
                  WORK_SHIFT_PATHS.work_shift_brigades,
                  { brigade_id: brigade.id }
                ]"
              >
                {{ brigadeExtra.brigade_name }}
              </a>
            </div>
          </div>
          <div class="grid mt-16">
            <div class="grid__box grid__box--size-5">
              <span class="title title--s">Бригадир</span>
            </div>
            <div class="grid__box grid__box--size-7">
              <div>
                {{ brigadeExtra.brigade_head && brigadeExtra.brigade_head.employee && brigadeExtra.brigade_head.employee.full_name }}
              </div>
              <div class="grid grid--gap-4">
                <div class="grid__box grid__box--size-min">
                  <app-icon [glyph]="'hd-phone-2'" [size]="'14'" [color]="'gray'"></app-icon>
                </div>
                <div class="grid__box grid__box--size-min">
                  <span class="text-italic color-gray-dark">
                    {{ brigadeExtra.brigade_head && brigadeExtra.brigade_head.employee && brigadeExtra.brigade_head.employee.phone | phoneFormat }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="grid mt-16" *ngIf="brigadeExtra.brigade_workers && brigadeExtra.brigade_workers.length">
            <div class="grid__box grid__box--size-5">
              <span class="title title--s">Состав</span>
            </div>
            <div class="grid__box grid__box--size-7">
              <div [ngClass]="{ 'mb-8': !last }" *ngFor="let worker of brigadeExtra.brigade_workers; let last = last">
                {{ worker && worker.employee && worker.employee.full_name }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="brigadeError" class="w-320">
        <app-message [type]="'error'">
          <div message-content>{{ brigadeError }}</div>
        </app-message>
      </div>
    </div>
  </div>
</ng-template>
